import { useEffect } from 'react'
import { atom, useAtomValue, useSetAtom } from 'jotai'
import { useHydrateAtoms } from 'jotai/utils'
import { type PriceTemplate } from '@/services/PriceCalculator/PriceCalculator.types'

export const priceTemplateAtom = atom<PriceTemplate | null>(null)

export const usePriceTemplate = () => {
  const value = useAtomValue(priceTemplateAtom)
  if (value == null) {
    throw new Error('priceTemplateAtom must be set')
  }
  return value
}

export const useSyncPriceTemplate = (template: PriceTemplate) => {
  useHydrateAtoms([[priceTemplateAtom, template]])
  const setTemplate = useSetAtom(priceTemplateAtom)
  useEffect(() => {
    setTemplate(template)
  }, [template, setTemplate])
}
